import React from 'react'
import clsx from 'clsx'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Image } from '@/components/atoms/Image/Image'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { Video } from '../Video/Video'
import { CardProps } from './types'
import * as styles from './Card.module.css'

export function Card({
  heading,
  text,
  link,
  image,
  wide,
  secondary,
  className,
  centerBtn,
  embed_video_url
}: CardProps) {
  return (
    <article
      className={clsx(
        'mb-28 last:mb-0 max-w-xs tablet:max-w-full min-h-full flex flex-col tablet:p-16 gap-16 tablet:w-1/2',
        wide ? 'netbook:w-1/2' : 'netbook:w-1/3',
        className
      )}
    >
      {image && !embed_video_url && (
        <div className={clsx(styles.thumbnailHolder, 'relative')}>
          <Image
            fixed={false}
            fluid
            data={image}
            options={{ width: 400, maxWidth: 500, quality: 100 }}
            className="w-full h-full z-8 !absolute top-0 left-0"
          />
        </div>
      )}
      {embed_video_url && <Video url={embed_video_url} thumbnail={image} inCard />}
      <div className="mt-16">
        <h3
          className={clsx(
            'text-headingS-mobile font-bold block mb-16 netbook:text-headingS font-poppins',
            secondary ? 'text-text-dark-600' : 'text-text-dark-900'
          )}
        >
          {heading}
        </h3>
        <div className={clsx('text-bodyL text-text-dark-900 mb-8', link.length && 'mb-24 tablet:mb-16')}>
          {typeof text === 'string' ? text : <RichTextField data={text} />}
        </div>
        {link.map((element) => (
          <CustomLink
            {...element}
            key={element._uid}
            className={clsx(centerBtn && 'tablet:!flex tablet:!items-center')}
          >
            <div className={clsx('flex items-center', centerBtn && 'tablet:mx-auto')}>
              <p
                className={clsx(
                  'text-bodyL font-bold hover:text-primary-400',
                  secondary ? 'text-text-dark-600' : 'text-primary-500'
                )}
              >
                {element.text}
              </p>
              <i
                className={clsx(
                  'fa fa-long-arrow-right hover:text-primary-400 ml-8',
                  secondary ? 'text-text-dark-600' : 'text-primary-500'
                )}
              />
            </div>
          </CustomLink>
        ))}
      </div>
    </article>
  )
}
